import {Record, OrderedMap} from 'immutable';

const DEFAULT_STATE = {
  images: OrderedMap(),
  height: 0,
};

const BaseRecord = Record(DEFAULT_STATE);

export class ColumnRecord extends BaseRecord {
  addImage(image) {
    const {id, photos} = image;
    const sizes = photos[0].alt_sizes;
    const imageHeight = sizes[Math.max(sizes.length - 4, 0)].height;

    return this
      .setIn(['images', id], image)
      .set('height', this.height + imageHeight);
  }
}



// WEBPACK FOOTER //
// ./src/state/images/ColumnRecord.js